import React from 'react'
import { Link } from 'react-router-dom'
import CardUI from '../../../../widgets/layout/CardUI'
import FileUploadModalSF from '../../../../widgets/form/FileUploadModalSF'
import SpinnerUI from '../../../../widgets/output/SpinnerUI'
import GenericErrorUI from '../../../common/GenericErrorUI'
import LRTableBodyUI from '../../../../widgets/layout/LRTableBodyUI'
import LRTableRowUI from '../../../../widgets/layout/LRTableRowUI'
import FileUploadWithFileNameModalSF from '../../../../widgets/form/FileUploadWithFileNameModalSF'
import './LoanPropertyList.css'

const AnnexureDocumentUploadUI = ({
  context, loan, errorList,
  // Annexure 4 props
  annexure4UploadMode, annexure4UploadSubmitted, annexure4UploadSuccessMsg, annexure4UploadErrorList,
  onAnnexure4UploadClick, onAnnexure4UploadCancel, onAnnexure4Upload,
  // Annexure 5 props  
  annexure5UploadMode, annexure5UploadSubmitted, annexure5UploadSuccessMsg, annexure5UploadErrorList,
  onAnnexure5UploadClick, onAnnexure5UploadCancel, onAnnexure5Upload,
  // Download props
  onAnnexure4FileDownload, onAnnexure5FileDownload,
  // Delete props
  deleteAnnexureIVFileMode, onAnnexureIVFileDeleteClick, deleteAnnexureVFileMode, onAnnexureVFileDeleteClick, selectedFile,
}) =>
  <CardUI className='su_l_annexure_upload g_m_top_100' title='Annexure File Upload' noUnderline={true}>
    <LRTableBodyUI>
      <LRTableRowUI
        context={context}
        left={<AnnexureIVRowLeftUI context={context} loan={loan}
          title={loan.loanSubType === 'vehicle_loan' ? 'Annexure VI' : 'Annexure IV'}
          onDownloadClick={onAnnexure4FileDownload}
          onDeleteClick={onAnnexureIVFileDeleteClick}
          deleteMode={deleteAnnexureIVFileMode}
        />}
        right={<AnnexureIVRowRightUI loan={loan}
          onUploadClick={onAnnexure4UploadClick}
          successMsg={annexure4UploadSuccessMsg}
          errorList={annexure4UploadErrorList}
        />}
      />
      <LRTableRowUI
        context={context}
        left={<AnnexureVRowLeftUI context={context} loan={loan}
          title={loan.loanSubType === 'vehicle_loan' ? 'Annexure VII' : 'Annexure V'}
          onDownloadClick={onAnnexure5FileDownload}
          onDeleteClick={onAnnexureVFileDeleteClick}
          deleteMode={deleteAnnexureVFileMode}
          selectedFile={selectedFile}
        />}
        right={<AnnexureVRowRightUI loan={loan}
          onUploadClick={onAnnexure5UploadClick}
          successMsg={annexure5UploadSuccessMsg}
          errorList={annexure5UploadErrorList}
        />}
      />
    </LRTableBodyUI>

    {/* <FileUploadModalSF
      context={context}
      titleLabel='Upload Annexure 4 Document'
      uploadMode={annexure4UploadMode}
      onCancelClick={onAnnexure4UploadCancel}
      signedUrlApi={`/api/su/loans/${loan.loanId}/documents/loanAgreement/annexureIV/fileUploadSignedUrl`}
      onUpload={onAnnexure4Upload}
    /> */}

    <FileUploadWithFileNameModalSF
      context={context}
      uploadMode={annexure4UploadMode}
      onCancelClick={onAnnexure4UploadCancel}
      signedUrlApi={`/api/su/loans/${loan.loanId}/documents/loanAgreement/annexureIV/fileUploadSignedUrl`}
      onUpload={onAnnexure4Upload}
      hint={loan.loanSubType === 'vehicle_loan'
        ? 'The title of annexure VI will be determined by the file name'
        : 'The title of annexure IV will be determined by the file name'}
    />

    {/* <FileUploadModalSF
      context={context}
      titleLabel='Upload Annexure 5 Document'
      uploadMode={annexure5UploadMode}
      onCancelClick={onAnnexure5UploadCancel}
      signedUrlApi={`/api/su/loans/${loan.loanId}/documents/loanAgreement/annexureV/fileUploadSignedUrl`}
      onUpload={onAnnexure5Upload}
    /> */}

    <FileUploadWithFileNameModalSF
      context={context}
      uploadMode={annexure5UploadMode}
      onCancelClick={onAnnexure5UploadCancel}
      signedUrlApi={`/api/su/loans/${loan.loanId}/documents/loanAgreement/annexureV/fileUploadSignedUrl`}
      onUpload={onAnnexure5Upload}
      hint={loan.loanSubType === 'vehicle_loan'
        ? 'The title of annexure VII will be determined by the file name'
        : 'The title of annexure V will be determined by the file name'}
    />
  </CardUI>

const AnnexureIVRowLeftUI = ({ context, loan, title, onDownloadClick, onDeleteClick, deleteMode }) =>
  <div className='g_flex_v g_flex_left'>
    {title}
    {
      loan.loanAgreementAnnexureIVFileName === null &&
      <span>File not uploaded</span>
    }
    {
      loan.loanAgreementAnnexureIVFileName &&
      <span className='g_flex_h g_flex_left'>
        <Link onClick={onDownloadClick} to='#' data-file-name={loan.loanAgreementAnnexureIVFileName}>
          {loan.loanAgreementAnnexureIVFileName}
        </Link>
        <span className='icon icon-trash-o g_m_left_50 g_m_right_50' onClick={onDeleteClick} data-file-name={loan.loanAgreementAnnexureIVFileName} />
        <SpinnerUI show={deleteMode} />
      </span>
    }
  </div>

const AnnexureIVRowRightUI = ({ context, loan, onUploadClick, successMsg, errorList }) =>
  <div>
    {
      loan.loanAgreementAnnexureIVFileName === null &&
      <>
        <Link to='#' onClick={onUploadClick}>
          Upload
        </Link>
        {
          successMsg &&
          <div className='g_success'>{successMsg}</div>
        }
        {
          errorList && errorList.length > 0 &&
          <div className='g_error'>{errorList[0]}</div>
        }
      </>
    }
  </div>

const AnnexureVRowLeftUI = ({ context, loan, title, onDownloadClick, onDeleteClick, deleteMode, selectedFile }) =>
  <div className='g_flex_v g_flex_left'>
    {title}
    {
      loan.loanAgreementAnnexureVFileNameList.length === 0 &&
      <span>Files not uploaded</span>
    }
    {
      loan.loanAgreementAnnexureVFileNameList.map((fileName, i) =>
        <span className='g_flex_h g_flex_left' key={i}>
          <Link onClick={onDownloadClick} to='#' data-file-name={fileName}>
            {fileName}
          </Link>
          <span className='icon icon-trash-o g_m_left_50 g_m_right_50' onClick={onDeleteClick} data-file-name={fileName} />
          <SpinnerUI show={selectedFile === fileName && deleteMode} />
        </span>
      )
    }
  </div>

const AnnexureVRowRightUI = ({ context, loan, onUploadClick, successMsg, errorList }) =>
  <div>
    <Link to='#' onClick={onUploadClick}>
      Upload
    </Link>
    {
      successMsg &&
      <div className='g_success'>{successMsg}</div>
    }

    {
      errorList && errorList.length > 0 &&
      <div className='g_error'>{errorList[0]}</div>
    }
  </div>

export default AnnexureDocumentUploadUI
